import { IApplicationState } from '../../types/redux';

// TODO: Добавить эксперимент в CD-199899.
export const selectLeadFactoryPageExperimentActive = (_state: IApplicationState): boolean => {
  return false;
};
